/*!

=========================================================
* Light Bootstrap Dashboard React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/light-bootstrap-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  Panel,
  Image
} from "react-bootstrap";
import { Card } from "components/Card/Card.jsx";
import { FormInputs } from "components/FormInputs/FormInputs.jsx";
import { UserCard } from "components/UserCard/UserCard.jsx";
import Button from "components/CustomButton/CustomButton.jsx";

import avatar from "assets/img/faces/face-3.jpg";
import firebase from 'firebase';


class EditarTelas extends Component {
    constructor(props){
      super(props)
      this.componentDidMount.bind(this)
      this.handleSubmit = this.handleSubmit.bind(this)
      this.fileInput = React.createRef();
      this.handleChange = this.handleChange.bind(this);
      this.handleChangeInfo = this.handleChangeInfo.bind(this);

      this.state = {
          telas:[
           
          ],
          tela:{nome:'',titulo:'',info:''}
      }
      
      this.mudarTela.bind(this)
  }
  componentDidMount(){
    
    firebase.database().ref('/telas').on('value',(snapshot)=>{
      const telas = snapshot.val()
      let telasArray = []
      for (const key in telas) {
        if (telas.hasOwnProperty(key)) {
          const tela = telas[key];
          console.log('TELA NOME',key,'TELA OBJETO',tela)
          telasArray.push(tela)
          
        }
      }
      console.log('TELAS CARREGADAS',telasArray)
      this.setState({telas:telasArray,tela:telasArray[0]})
    })
    
  }
  mudarTela(tela){
    console.log(tela)
    this.setState({
      tela:tela
    })
  }
  
  handleChange(e) {
    console.log(e.target.value)
    let tela = this.state.tela
    tela.titulo = e.target.value
    this.setState({ tela  });
  }
  handleChangeInfo(e) {
    console.log(e.target.value)
    let tela = this.state.tela
    tela.info = e.target.value
    this.setState({ tela  });
  }


  handleSubmit(event) {
    try{
      event.preventDefault();  
      let titulo = event.target[0].value
      let info = event.target[2].value
      let tela = this.state.tela
      let nome = this.state.tela.nome
      let imagem = this.state.tela.imagem
      if(!titulo) titulo = this.state.tela.titulo
      if(!info) info = this.state.tela.info
      let mensagem = `Tela ${this.state.tela.nome} Atualizada com Sucesso!!!`
      let icone = 'pe-7s-info'
      console.log('titulo',titulo)
      console.log('informacao',info)
      console.log('TELA',tela)    
      if(this.fileInput.current.files && (this.fileInput.current.files.length > 0 ) &&  this.fileInput.current.files[0].name ) {
        this.props.handleClick("tr","Fazendo upload da Imagem",'pe-7s-photo')
        let file = this.fileInput.current.files[0]
        let imagens = firebase.storage().ref(`/imagens/${file.name}`)

        imagens.put(file).then((res)=>{
          console.log('upload status',res)
          res.ref.getDownloadURL().then((url)=>{
            console.log('url da imagme',url)
            imagem = url
            firebase.database().ref(`telas/${this.state.tela.nome}`).set({
              titulo,
              info,
              nome:this.state.tela.nome,
              imagem:url
            })
            this.setState({tela:{imagem,info,titulo,nome}})
            this.props.handleClick("tr",mensagem,icone)
          })
        })
      }else{
        firebase.database().ref(`telas/${this.state.tela.nome}`).set({
          titulo,
          info,
          nome:this.state.tela.nome,
          imagem:this.state.tela.imagem
        })
        this.setState({tela:{imagem,info,titulo,nome}})
        this.props.handleClick("tr",mensagem,icone)
      }
      
    
    }catch(e){
      console.log('HOUVE UM ERRO NO SUBMIT',e);
    }
  
    

   
  }
  render() {
    return (
      <div className="content">
        <Grid fluid>
          <Row>
              <Col style={{marginLeft:13,marginBottom:10}}>
                  {
                      this.state.telas.map((tela)=>(
                        <Button onClick={()=>this.mudarTela(tela)} style={{margin:2}} bsStyle="info"  fill type="submit">
                            {tela.nome}
                         </Button>
                      ))
                  }
                  
              </Col>
          </Row>
          <Row>
            <Col md={8}>
              <Card
                title={this.state.tela.nome}
                content={
                  <form onSubmit={this.handleSubmit}>
                    
                    
                    <FormInputs
                      ncols={["col-md-12"]}
                      onChange={this.handleChange}
                      properties={[
                        {
                          label: "Titulo:",
                          type: "text",
                          bsClass: "form-control",
                          placeholder: "Titulo",
                          value:`${this.state.tela.titulo}`,
                          onChange:this.handleChange
                          
                        }
                      ]}
                    />

                    <Row>
                      <Col md={12}>
                      <label>
                        Imagem:
                        <input accept="image/png, image/jpeg" type="file" ref={this.fileInput} />
                      </label>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12}>
                        <FormGroup controlId="formControlsTextarea">
                          <ControlLabel>Descrição</ControlLabel>
                          <FormControl
                            rows="5"
                            componentClass="textarea"
                            bsClass="form-control"
                            placeholder="Descrição que aparece na tela do celular"
                            value={`${this.state.tela.info}`}
                            onChange={this.handleChangeInfo}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Button bsStyle="info" pullRight fill type="submit">
                      Atualizar Tela
                    </Button>
                    <div className="clearfix" />
                  </form>
                }
              />
            </Col>
            <Col md={4}>
              <Panel>
                <Panel.Heading>{this.state.tela.titulo}</Panel.Heading>
                <Panel.Body>
                <Grid>
                <Row>
                  <Col md={5}>
                    <Image src={this.state.tela.imagem} thumbnail />

                  </Col>
                </Row>
                </Grid>
               
                  <h3>{this.state.tela.titulo}</h3>
                  <h5>{this.state.tela.info}</h5>                  
                </Panel.Body>
              </Panel> 
              
            
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default EditarTelas;
